import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullDeal from "./fragments/fullDeal"

const query = gql`
  query DealsList(
    $offset: Int
    $limit: Int
    $sort: DealListSort
    $uuids: [String]
    $tags: [String]
    $locationTags: [String]
    $types: [DealType]
    $statuses: [DealStatus!]
    $locale: String
    $q: String
    $ignoreBlacklist: Boolean
    $ignorePackage: Boolean
    $ttOnly: Boolean
    $provider: PendingDealProvider
    $regions: [ID!]
    $isRewards: Boolean
    $reviewState: DealReviewState
    $brandIds: [ID!]
    $noTt: Boolean
    $customDealType: String
  ) {
    deals(
      offset: $offset
      limit: $limit
      sort: $sort
      uuids: $uuids
      tags: $tags
      locationTags: $locationTags
      types: $types
      statuses: $statuses
      locale: $locale
      q: $q
      ignoreBlacklist: $ignoreBlacklist
      ignorePackage: $ignorePackage
      ttOnly: $ttOnly
      provider: $provider
      regions: $regions
      isRewards: $isRewards
      reviewState: $reviewState
      brandIds: $brandIds
      noTt: $noTt
      customDealType: $customDealType
    ) {
      results {
        ...fullDeal
      }
      hasMore
      total
      offset
      limit
    }
  }
  ${fullDeal}
`

export const dealListQueryKey = getQueryNames(query)[0]

export default query
